import React from 'react';
import OnboardingPageOverlay from '../../shared/OnboardingPageOverlay';
import InventoryOnboardingStep from './InventoryOnboardingStep';

const InventoryOnboardingOverlay: React.FC = () => (
  <OnboardingPageOverlay stepId="inventory">
    {(onDismiss) => <InventoryOnboardingStep onDismiss={onDismiss} />}
  </OnboardingPageOverlay>
);

export default InventoryOnboardingOverlay;
